import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export const handlePrefilledDate = (date: string) => {
  if (date) {
    const jsDate = dayjs.utc(date)
    return {
      day: jsDate.get('date'),
      month: jsDate.get('month') + 1,
      year: jsDate.get('year'),
    }
  }
  return {}
}
